<template>
  <span class="d-none"><slot /></span>
</template>
<script>
import BodyController from "@/mixins/BodyController";
import DeviceMixinMain from "@/mixins/DeviceMixinMain";

export default {
  name: "BodyControllerComponent",
  mixins: [BodyController, DeviceMixinMain],
  created() {
    this.$root.$BodyController = this;
  },
  watch: {
    isMobileValue: {
      handler: function () {
        this.adjustBody();
      },
    },
    isTabletValue: {
      handler: function () {
        this.adjustBody();
      },
    },
    isDesktopValue: {
      handler: function () {
        this.adjustBody();
      },
    },
  },
};
</script>
